import {
  EffectComposer,
  Bloom,
  Vignette,
  HueSaturation,
  BrightnessContrast,
} from "@react-three/postprocessing";

/**
 * Post-processing stack for the lobby. ACES tonemapping is set on the
 * <Canvas gl={...}> upstream — this composer adds the medieval-cathedral
 * look on top: bloom on emissive surfaces (window slits + torches),
 * warm color grade, mild contrast lift, and a soft vignette.
 *
 * Skipped entirely on touch devices (see Lobby.tsx) — the savings on
 * fragment shader passes are large on integrated mobile GPUs, and the
 * ACES tonemap alone still carries most of the look.
 */
export function PostFX(): JSX.Element {
  return (
    <EffectComposer multisampling={0} enableNormalPass={false}>
      <Bloom
        intensity={0.55}
        luminanceThreshold={0.65}
        luminanceSmoothing={0.22}
        mipmapBlur
      />
      <HueSaturation hue={0} saturation={0.06} />
      <BrightnessContrast brightness={-0.02} contrast={0.14} />
      <Vignette eskil={false} offset={0.18} darkness={0.62} />
    </EffectComposer>
  );
}
